import primitives from "./primitives";

const semantics = {
  primary: {
    main: primitives.color.teal[500],
    dark: primitives.color.teal[700],
    light: primitives.color.teal[100],
  },
  transparent: {
    pure: primitives.color.transparent[0],
    light: primitives.color.transparent[50],
    medium: primitives.color.transparent[100],
    heavy: primitives.color.transparent[200],
  },
  surface: {
    page: primitives.color.neutral[0],
    card: primitives.color.neutral[0],
    subtle: primitives.color.neutral[100],
    overlay: primitives.color.neutral[50],
  },
  text: {
    primary: primitives.color.neutral[950],
    secondary: primitives.color.neutral[500],
    placeholder: primitives.color.neutral[500], // also used for disabled
    brand: primitives.color.teal[500],
  },
  border: {
    default: primitives.color.neutral[300],
    strong: primitives.color.neutral[900],
    focus: primitives.color.teal[500],
    subtle: primitives.color.neutral[200],
  },
  brand: {
    primary: primitives.color.teal[500],
    dark: primitives.color.teal[700],
    light: primitives.color.teal[300],
  },
  secondary: {
    main: primitives.color.neutral[900],
    dark: primitives.color.neutral[900],
    light: primitives.color.neutral[700],
  },
  positive: {
    text: primitives.color.green[600],
    bg: primitives.color.green[50],
  },
  negative: {
    text: primitives.color.red[500],
    bg: primitives.color.red[50],
  },
  success: {
    main: primitives.color.green[600],
    dark: primitives.color.green[800],
    light: primitives.color.green[100],
  },
  error: {
    main: primitives.color.red[500],
    dark: primitives.color.red[700],
    light: primitives.color.red[300],
  },
  warning: {
    main: primitives.color.yellow.main,
    light: primitives.color.yellow.light,
    dark: primitives.color.yellow.dark,
  },
  info: {
    main: primitives.color.navy[500],
    light: primitives.color.navy[300],
    dark: primitives.color.navy[500],
  },
  map: {
    primary: primitives.color.teal[300],
    secondary: primitives.color.neutral[300],
    text: primitives.color.neutral[950],
    legend: primitives.color.neutral[700],
  },

  levelColors: primitives.levelColors,
  changeMarkers: {
    ...primitives.color.chartMarkers,
  },

  typography: {
    weight: { ...primitives.typography.weight },
    size: { ...primitives.typography.size },
  },

  radius: { ...primitives.radius },
};

export default semantics;
